import { RefObject, useRef } from 'react';
import { ModalRef } from '../components';

export function useModal(): RefObject<ModalRef> {
  const ref = useRef<ModalRef>(null);

  return ref;
}
